import qs from 'qs';

import browser from '@openclassrooms/utils/browser';
import { getActiveLang } from '@openclassrooms/translations';
import getWebAppRouteKey from './getWebAppRouteKey';

import ROUTES from '../constants/routes';

const createRedirectLink =
  (url) =>
  (shouldPrependLang = !getWebAppRouteKey(document.location.pathname)) => {
    const {
      _target_path: targetPath,
      context,
      nowelcomequestions,
    } = qs.parse(browser.document?.location.search, {
      ignoreQueryPrefix: true,
    });

    const getArgs =
      targetPath || context || nowelcomequestions
        ? `?${qs.stringify({
            ...(context && { context }),
            ...(targetPath && { _target_path: targetPath }),
            ...(nowelcomequestions && { nowelcomequestions: 'true' }),
          })}`
        : '';
    const prefix = shouldPrependLang ? `/${getActiveLang()}` : '';
    return `${prefix}${url}${getArgs}`;
  };

export const getLoginUrl = createRedirectLink(ROUTES.AUTH.LOGIN);
export const getRegisterUrl = createRedirectLink(ROUTES.AUTH.REGISTER);
export const getRegisterByEmailUrl = createRedirectLink(ROUTES.AUTH.REGISTER_EMAIL);
